module.exports = __webpack_public_path__ + "static/img/3_1_2_3.399ffb1a.jpg";